import React from 'react';
import '../styles/components/pengu.scss'

const Pengu = ({link}) => (
    <div className="pengu-container">
        <a href={link} target="_blank" rel="noreferrer">
            <button className="store-link">Purchase</button>
        </a>
        <img src="./img/footer/prinny-silhouette.png" alt="prinny" />
    </div>
);

export default Pengu;